<router-outlet></router-outlet>
<div *ngIf="loading">
  <mat-spinner style="margin: 10% auto;"></mat-spinner>
</div>
